module.exports = {
      id: "range-break-100-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#range-break-100-index-usage",
      toString: function () {
        return this.url;
      }
    }